import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import actions from '@src/redux/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Format number with Vietnamese locale (adding commas as thousand separators)
const delimitNumber = (num) => {
  const number = Number(num);
  if (Number.isNaN(number)) return '';
  return number.toLocaleString('vi-VN'); // Format according to Vietnamese standard
};

const DiscountInput = ({
  id,
  label,
  name = 'discount',
  size = 'small',
  type = 'text',
  value,
  placeholder,
  onKeyDown,
  onChange,
  isError = false,
  helperText,
  customStyledInput = {},
  customInputProps = {},
  customClassName = '',
}) => {
  const [inputValue, setInputValue] = useState(value?.toString() || '');
  // Track if this is the first focus
  const [isFirstFocus, setIsFirstFocus] = useState(true);
  const [isCashDiscount, setCashDiscount] = useState(value >= 1000);
  const dispatch = useDispatch();

  // When value changes externally (via props), update inputValue
  useEffect(() => {
    setInputValue(
      value >= 1000 ? delimitNumber(value) : value?.toString() || '',
    );
  }, [value]);

  // Function to remove commas and periods for number formatting
  const parseNumber = (str) => str.replace(/\./g, '').replace(/,/g, ''); // Remove period and comma

  // Handle input change event
  const handleChange = (e) => {
    const raw = e.target.value;
    const parsed = parseNumber(raw); // Remove separators

    // Update the input value without affecting the separators
    setInputValue(raw);
    setCashDiscount(parsed >= 1000);

    // Return the raw value without separators to onChange
    onChange?.({
      ...e,
      target: {
        ...e.target,
        name,
        value: parsed, // Send the original value without separators
      },
    });
  };

  const getMessage = (isCashMode) => {
    dispatch(
      actions.noti.push({
        message: isCashMode
          ? 'Chiết khấu đang trong chế độ trừ tiền.'
          : 'Chiết khấu đang trong chế độ trừ theo phần trăm.',
        severity: 'info',
      }),
    );
  };

  // Handle focus event
  const handleFocus = () => {
    if (isFirstFocus) {
      setIsFirstFocus(false); // Set to false after the first focus
      getMessage(value >= 1000);
    }
  };

  useEffect(() => {
    if (!isFirstFocus) {
      getMessage(isCashDiscount);
    }
  }, [isCashDiscount]);

  return (
    <div className={customClassName}>
      {label && <Typography>{label}</Typography>}
      <TextField
        size={size}
        name={name}
        placeholder={placeholder}
        id={id}
        type={type}
        value={inputValue}
        onKeyDown={onKeyDown}
        onChange={handleChange}
        onFocus={handleFocus} // Add focus handler
        error={isError}
        helperText={helperText}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {Number(value) >= 1000 ? (
                'VND'
              ) : (
                <IconButton edge="end">%</IconButton>
              )}
            </InputAdornment>
          ),
          style: {
            ...customStyledInput,
          },
          ...customInputProps,
        }}
      />
    </div>
  );
};

export default DiscountInput;
